<template>
    <div>
        <div class="lv_flexalign_center" style="margin-bottom: 15px">
            <el-date-picker
                v-model="time"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
            ></el-date-picker>
            <el-input v-model="params.name" placeholder="搜索手机号、昵称" />
            <el-select v-model="params.isExpired" placeholder="请选择">
                <el-option value="" label="全部状态" />
                <el-option :value="1" label="已过期" />
                <el-option :value="0" label="未过期" />
            </el-select>
            <el-button
                type="primary"
                @click="
                    params.pageNum = 1;
                    getList();
                "
            >
                搜索
            </el-button>
        </div>
        <div style="margin: 20px 0">
            <h1 style="font-size: 40px">{{ total }}</h1>
            <div style="margin-top: 10px">总计用户数</div>
        </div>
        <el-table :data="list" style="width: 100%">
            <el-table-column prop="name" label="昵称"></el-table-column>
            <el-table-column prop="phone" label="手机"></el-table-column>
            <el-table-column prop="profession" label="身份"></el-table-column>
            <el-table-column prop="area" label="地区"></el-table-column>
            <el-table-column prop="problem" label="问题"></el-table-column>
            <el-table-column prop="worksNum" label="作品"></el-table-column>
            <el-table-column prop="studentsNum" label="学生"></el-table-column>
            <el-table-column
                prop="createTime"
                label="注册时间"
            ></el-table-column>
            <el-table-column
                prop="lastLogin"
                label="最后登录时间"
            ></el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">
                    {{ scope.row.isExpired ? "已过期" : "未过期" }}
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="extendTime(scope.row.id)">
                        延长体验
                    </el-button>
                    <el-button type="text" @click="toFormal(scope.row.id)">
                        转正
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog
            title="延长体验"
            :visible.sync="extendData.show"
            width="300px"
        >
            <el-date-picker
                v-model="extendData.expiration"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
            ></el-date-picker>
            <span slot="footer" class="dialog-footer">
                <el-button @click="extendData.show = false">取消</el-button>
                <el-button type="primary" @click="confirmTime">确定</el-button>
            </span>
        </el-dialog>

        <el-pagination
            background
            layout="prev, pager, next,sizes"
            :total="total"
            :page-sizes="[10, 50, 100, 200]"
            :current-page.sync="params.pageNum"
            :page-size.sync="params.pageSize"
            @size-change="getList"
            @current-change="getList"
            style="margin-top: 15px"
        ></el-pagination>
        <el-dialog title="转正" :visible.sync="formalData.show" width="500px">
            <el-form label-width="80px">
                <el-form-item label="学校logo">
                    <el-upload
                        accept=".png,.jpg,.jpeg"
                        :show-file-list="false"
                        action=""
                        :before-upload="
                            file => {
                                handleUpload(file);
                                return false;
                            }
                        "
                    >
                        <div v-if="formalData.logo">
                            <img
                                :src="formalData.logo | imgFormat"
                                class="review-img"
                                style="height: auto"
                            />
                            <i
                                class="el-icon-close"
                                @click="formalData.logo = ''"
                                @click.stop=""
                            ></i>
                        </div>
                        <i
                            v-else
                            class="el-icon-plus avatar-uploader-icon"
                            style="font-size: 30px"
                        ></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="学校名称">
                    <el-input v-model="formalData.name"></el-input>
                </el-form-item>
                <el-form-item label="成交金额">
                    <el-input v-model="formalData.cost"></el-input>
                </el-form-item>
                <el-form-item label="有效期">
                    <el-date-picker
                        v-model="formalData.expiration"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择日期"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="签约版本">
                    <el-radio
                        v-model="formalData.versionId"
                        :label="item.id"
                        v-for="item in versionList"
                        :key="item.id"
                    >
                        {{ item.version }}
                    </el-radio>
                </el-form-item>
                <el-form-item>
                    <el-button @click="confirmFormal">确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
export default {
    created() {
        this.getList();
        this.getVersionList();
    },
    data() {
        return {
            versionList: [],
            formalData: {
                id: "",
                expiration: "",
                show: false,
                name: "",
                versionId: "",
                cost: 0,
                logo: "",
            },
            extendData: {
                id: "",
                expiration: "",
                show: false,
            },
            list: [],
            total: 0,
            time: [],
            params: {
                pageNum: 1,
                pageSize: 10,
                name: "",
                isExpired: "",
                timeStart: "",
                timeEnd: "",
            },

            ossUploadData: {},
        };
    },
    mounted() {
        this.getKey();
    },
    methods: {
        confirmFormal() {
            this.$ajax
                .post("/institution/official", this.formalData)
                .then(res => {
                    this.$message.success("保存成功");
                    this.formalData.show = false;
                    this.getList();
                });
        },
        toFormal(id) {
            this.formalData = {
                id,
                expiration: "",
                show: true,
                name: "",
                versionId: "",
                cost: 0,
            };
        },
        confirmTime() {
            this.$ajax.post("/institution/renew", this.extendData).then(res => {
                this.$message.success("保存成功");
                this.extendData.show = false;
                this.getList();
            });
        },
        extendTime(id) {
            this.extendData = {
                id,
                expiration: "",
                show: true,
            };
        },
        getList() {
            if (this.time.length) {
                this.params.timeStart = this.time[0];
                this.params.timeEnd = this.time[1];
            } else {
                this.params.timeStart = "";
                this.params.timeEnd = "";
            }
            this.$ajax
                .post("/institution/play/getList", this.params)
                .then(res => {
                    this.list = res.list;
                    this.total = res.total;
                });
        },
        getVersionList() {
            this.$ajax
                .post("/basic/version/getPage", {
                    pageNum: 1,
                    pageSize: 100,
                })
                .then(res => {
                    this.versionList = res.list;
                });
        },

        getKey() {
            this.$ajax
                .post("/user/oss/getKey?pathName=cover")
                .then(async res => {
                    this.ossUploadData.cover = res.data;
                });

            this.$ajax
                .post("/user/oss/getKey?pathName=common")
                .then(async res => {
                    this.ossUploadData.material = Object.assign(res.data, {
                        path: "common/" + new Date().getTime() + "/",
                    });
                });
        },
        //单文件上传文件
        handleUpload(file) {
            this.getUploadPromise(
                {
                    file,
                },
                this.ossUploadData.cover
            ).then(res => {
                this.$set(this.formalData, "logo", res.addr);
                console.log(res.addr, "123", this.formalData.logo);
                // this.formalData.logo = res.addr;
            });
        },
    },
};
</script>

<style></style>
